/* =========================================================
   北海い～ど theme — interactions
   ========================================================= */
(function () {
  'use strict';
  const money = (cents) => window.Shopify && window.Shopify.formatMoney
    ? window.Shopify.formatMoney(cents, window.themeMoneyFormat)
    : '¥' + (cents / 100).toLocaleString('ja-JP');

  /* ---------- theme toggle ---------- */
  const root = document.documentElement;
  const saved = localStorage.getItem('uminagi-theme');
  if (saved) root.setAttribute('data-theme', saved);
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-theme-toggle]');
    if (!t) return;
    const cur = root.getAttribute('data-theme') ||
      (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    const next = cur === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    localStorage.setItem('uminagi-theme', next);
  });

  /* ---------- generic open/close (drawers) ---------- */
  function toggleDrawer(sel, open) {
    const el = document.querySelector(sel);
    const bd = document.querySelector('[data-drawer-backdrop]');
    if (!el) return;
    el.classList.toggle('is-open', open);
    if (bd) bd.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', (e) => {
    const openNav = e.target.closest('[data-open-nav]');
    const openCart = e.target.closest('[data-open-cart]');
    const openSearch = e.target.closest('[data-open-search]');
    const closeEl = e.target.closest('[data-drawer-close]');
    const backdrop = e.target.closest('[data-drawer-backdrop]');
    if (openNav) { toggleDrawer('.nav-drawer', true); }
    if (openCart) { e.preventDefault(); toggleDrawer('.cart-drawer', true); refreshCart(); }
    if (openSearch) {
      e.preventDefault();
      toggleDrawer('.search-panel', true);
      const input = document.querySelector('[data-search-input]');
      if (input) setTimeout(() => input.focus(), 50);
    }
    if (closeEl || backdrop) {
      toggleDrawer('.nav-drawer', false);
      toggleDrawer('.cart-drawer', false);
      toggleDrawer('.search-panel', false);
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      toggleDrawer('.nav-drawer', false);
      toggleDrawer('.cart-drawer', false);
      toggleDrawer('.search-panel', false);
    }
  });

  /* ---------- predictive search（ページ遷移せずインクリメンタル検索） ---------- */
  (function () {
    const panel = document.querySelector('[data-search-panel]');
    const input = document.querySelector('[data-search-input]');
    const results = document.querySelector('[data-search-results]');
    if (!panel || !input || !results) return;
    const searchUrl = panel.dataset.searchUrl;
    let timer = null;
    let controller = null;

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    /* predictive-search(JSON)APIはこのショップで "Unsupported buyer locale" エラーになり使えないため、
       既存の /search ページ(HTML)を裏で取得し .pcard をパースして流用する。 */
    function render(term, cards) {
      if (!cards.length) {
        results.innerHTML = `<p class="search-panel__empty">「${escapeHtml(term)}」に一致する商品は見つかりませんでした。</p>`;
        return;
      }
      const items = cards.map((card) => {
        const link = card.querySelector('.pcard__title a');
        const img = card.querySelector('.pcard__media img');
        const price = card.querySelector('.pcard__price-row .price');
        if (!link) return '';
        return `
          <a class="search-result" href="${link.getAttribute('href')}">
            <div class="search-result__img">${img ? `<img src="${img.getAttribute('src')}" alt="" loading="lazy">` : ''}</div>
            <div>
              <div class="search-result__title">${escapeHtml(link.textContent.trim())}</div>
              <div class="search-result__price num">${price ? escapeHtml(price.textContent.trim()) : ''}</div>
            </div>
          </a>`;
      }).join('');
      results.innerHTML = items + `<a class="search-panel__more" href="${searchUrl}?q=${encodeURIComponent(term)}&type=product">「${escapeHtml(term)}」の検索結果をすべて見る →</a>`;
    }

    async function runSearch(term) {
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const res = await fetch(`${searchUrl}?q=${encodeURIComponent(term)}&type=product`, { signal: controller.signal });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = Array.from(doc.querySelectorAll('.product-grid .pcard')).slice(0, 6);
        render(term, cards);
      } catch (err) {
        if (err.name !== 'AbortError') console.error(err);
      }
    }

    input.addEventListener('input', () => {
      const term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(() => runSearch(term), 250);
    });
  })();

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    const wrap = btn.closest('.qty');
    const input = wrap && wrap.querySelector('input');
    if (!input) return;
    const step = parseInt(btn.dataset.qtyStep, 10);
    let val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart: fetch + render drawer ---------- */
  const cartCountEls = () => document.querySelectorAll('[data-cart-count]');
  function updateCount(count) {
    cartCountEls().forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }
  function renderDrawer(cart) {
    const list = document.querySelector('[data-cart-drawer-items]');
    const foot = document.querySelector('[data-cart-drawer-foot]');
    const empty = document.querySelector('[data-cart-drawer-empty]');
    if (!list) return;
    updateCount(cart.item_count);
    if (cart.item_count === 0) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;
    list.innerHTML = cart.items.map((it) => `
      <div class="cart-line" data-key="${it.key}">
        <div class="cart-line__img">${it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?.*)?$/,'_160x$1$2')}" alt="" loading="lazy">` : ''}</div>
        <div>
          <div class="cart-line__title">${it.product_title}</div>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="cart-line__meta">${it.variant_title}</div>` : ''}
          <div class="qty" style="margin-top:.5rem">
            <button type="button" data-cart-qty="${it.key}" data-to="${it.quantity - 1}" aria-label="減らす">−</button>
            <input value="${it.quantity}" readonly aria-label="数量">
            <button type="button" data-cart-qty="${it.key}" data-to="${it.quantity + 1}" aria-label="増やす">＋</button>
          </div>
          <button class="cart-line__remove" data-cart-qty="${it.key}" data-to="0">削除</button>
        </div>
        <div class="cart-line__price num">${money(it.final_line_price)}</div>
      </div>`).join('');
    const totalEl = document.querySelector('[data-cart-drawer-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }
  async function refreshCart() {
    try { renderDrawer(await getCart()); } catch (err) { console.error(err); }
  }
  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const cart = await res.json();
    renderDrawer(cart);
    if (document.body.classList.contains('template-cart')) location.reload();
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    changeLine(btn.dataset.cartQty, parseInt(btn.dataset.to, 10));
  });

  /* ---------- add to cart (AJAX) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add-btn]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '追加中…'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      });
      if (!res.ok) throw new Error('add failed');
      await refreshCart();
      toggleDrawer('.cart-drawer', true);
      if (btn) btn.textContent = 'かごに入れました ✓';
    } catch (err) {
      console.error(err);
      if (btn) btn.textContent = '在庫を確認してください';
    } finally {
      setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1400);
    }
  });

  /* ---------- quick add from product cards ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.quickAdd;
    btn.disabled = true;
    const orig = btn.textContent; btn.textContent = '…';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      await refreshCart();
      toggleDrawer('.cart-drawer', true);
    } catch (err) { console.error(err); }
    finally { btn.disabled = false; btn.textContent = orig; }
  });

  /* ---------- product gallery thumbnails (画像 / 動画 / YouTube・Vimeo) ---------- */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('.product__gallery');
    if (!gallery) return;

    const items = gallery.querySelectorAll('[data-media-item]');
    const index = Number(thumb.dataset.index);
    const next = items[index];
    if (!next || next.classList.contains('is-active')) return;

    /* 表示を離れるメディアの再生を止める */
    const prev = gallery.querySelector('[data-media-item].is-active');
    if (prev) {
      const video = prev.querySelector('video');
      if (video) video.pause();
      /* YouTube/Vimeo は src を入れ直して停止（JS APIが有効でないため） */
      const iframe = prev.querySelector('iframe');
      if (iframe && iframe.src) iframe.src = iframe.src;
      prev.classList.remove('is-active');
    }
    next.classList.add('is-active');

    /* 動画スライドに切り替わったら自動再生を再開（ミュートなので許可される） */
    const nextVideo = next.querySelector('video[autoplay]');
    if (nextVideo) {
      const p = nextVideo.play();
      if (p && p.catch) p.catch(() => {});
    }

    gallery.querySelectorAll('[data-thumb]').forEach((t) => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  });

  /* ---------- collection sort ---------- */
  const sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      location.href = url.toString();
    });
  }

  /* init count on load */
  getCart().then((c) => updateCount(c.item_count)).catch(() => {});
})();
